__turbopack_context__.v({
  "dismiss-button": "InterviewRecruitment-module-scss-module__3CGn1W__dismiss-button",
  "wrapper": "InterviewRecruitment-module-scss-module__3CGn1W__wrapper",
});
